<script setup lang="ts">
import './assets/style.scss'
import { computed, ref } from 'vue'
import { useMapMoveStore } from '../model/model.ts'
import { VIcons } from '@/shared/ui'

const store = useMapMoveStore()

const openPanels = ref<number[]>([])

const entriesList = computed(() => [...store.entries.values()])

const handleConfirmOne = (objectId: number) => {
  store.confirmOne(objectId)
}

const handleCancelOne = (objectId: number) => {
  store.cancelOne(objectId)
}

const handleConfirmAll = (event: MouseEvent) => {
  event.stopPropagation()
  store.confirmAll()
  openPanels.value = []
}

const handleCancelAll = (event: MouseEvent) => {
  event.stopPropagation()
  store.cancelAll()
  openPanels.value = []
}
</script>

<template>
  <div v-if="store.entries.size > 0" class="w-map-move-confirm">
    <VExpansionPanels v-model="openPanels" multiple>
      <VExpansionPanel density="compact" :min-width="260">
        <template #title>
          <div class="w-map-move-confirm__header">
            <span class="w-map-move-confirm__title">
              Подтвердить перемещение ({{ store.entries.size }})
            </span>

            <div class="w-map-move-confirm__header-actions">
              <VTooltip location="top" :open-delay="500" :text="$t('itf.map_confirm_move_all')">
                <template #activator="{ props }">
                  <VBtn density="compact" v-bind="props" @click.stop="handleConfirmAll">
                    <VIcons icon="check" />
                  </VBtn>
                </template>
              </VTooltip>

              <VTooltip location="top" :open-delay="500" :text="$t('itf.map_cancel_move_all')">
                <template #activator="{ props }">
                  <VBtn density="compact" color="error" v-bind="props" @click.stop="handleCancelAll">
                    <VIcons icon="close" />
                  </VBtn>
                </template>
              </VTooltip>
            </div>
          </div>
        </template>

        <template #text>
          <div
            v-for="entry in entriesList"
            :key="entry.objectId"
            class="w-map-move-confirm__item"
          >
            <span class="w-map-move-confirm__item-name" :title="entry.name">
              {{ entry.name }}
            </span>

            <div class="w-map-move-confirm__item-actions">
              <VTooltip location="top" :open-delay="500" :text="$t('itf.map_confirm_move')">
                <template #activator="{ props }">
                  <VBtn density="compact" v-bind="props" @click="handleConfirmOne(entry.objectId)">
                    <VIcons icon="check" />
                  </VBtn>
                </template>
              </VTooltip>

              <VTooltip location="top" :open-delay="500" :text="$t('itf.map_cancel_move')">
                <template #activator="{ props }">
                  <VBtn
                    density="compact"
                    color="error"
                    v-bind="props"
                    @click="handleCancelOne(entry.objectId)"
                  >
                    <VIcons icon="close" />
                  </VBtn>
                </template>
              </VTooltip>
            </div>
          </div>
        </template>
      </VExpansionPanel>
    </VExpansionPanels>
  </div>
</template>
